{
  "native": {
    "language": "English",
    "variant": "United Kingdom",
    "variantHint": "colour, organise",
    "testPhrase": "The weather is lovely today"
  },
  "roleplay": {
    "list": {
      "title": "Role Play",
      "sectionYours": "Your Role Plays",
      "createCustom": "Create custom role play",
      "slotsFull": "{{cap}}/{{cap}} slots used",
      "slotLabel": "{{title}} — {{scenario}}",
      "templateLabel": "{{title}}",
      "loadErrorRetry": "Retry"
    },
    "templates": {
      "preview": {
        "title": "Role Play Preview",
        "sectionVocabulary": "Vocabulary",
        "sectionPhrases": "Key Phrases",
        "startButton": "Start this Role Play",
        "statusNew": "New",
        "statusLearning": "Learning",
        "statusMastered": "Mastered"
      }
    },
    "collections": {
      "sectionTitle": "Collections",
      "progress": "{{completed}}/{{total}} done",
      "cardLabel": "{{title}}, {{completed}} of {{total}} done",
      "searchPlaceholder": "Search role plays",
      "searchClear": "Clear search",
      "searchEmpty": "No matches. Try a different keyword.",
      "emptyHint": "No collections available yet.",
      "difficultyLabel": "Lvl {{level}}",
      "filterDifficultyLabel": "Filter by difficulty level {{level}}",
      "filterCompleted": "Completed",
      "filterUncompleted": "Not yet started"
    }
  },
  "soundMap": {
    "title": "Sound Map",
    "loading": "Loading your sound map...",
    "loadError": "Unable to load your sound map.",
    "progressLabel": "{{mastered}} of {{total}} sounds mastered",
    "summary": {
      "mastered_one": "{{count}} mastered",
      "mastered_other": "{{count}} mastered",
      "learning_one": "{{count}} learning",
      "learning_other": "{{count}} learning",
      "weak_one": "{{count}} weak",
      "weak_other": "{{count}} weak",
      "untried_one": "{{count}} not tried",
      "untried_other": "{{count}} not tried"
    },
    "sections": {
      "consonants": "Consonants",
      "vowels": "Vowels",
      "diphthongs": "Diphthongs",
      "tones": "Tones"
    },
    "states": {
      "mastered": "Mastered",
      "learning": "Learning",
      "weak": "Weak",
      "untried": "Not tried yet"
    },
    "chip": {
      "scoreValue": "{{score}}%",
      "a11yMastered": "{{symbol}}, mastered, {{score}} percent",
      "a11yLearning": "{{symbol}}, learning, {{score}} percent",
      "a11yWeak": "{{symbol}}, weak, {{score}} percent",
      "a11yUntried": "{{symbol}}, not practised yet",
      "a11yUntriedHard": "{{symbol}}, not practised yet, expected to be hard"
    },
    "detail": {
      "exampleWordsTitle": "Example words",
      "statsAvgScore": "Average score",
      "statsAttempts": "Attempts",
      "statsLastPracticed": "Last practised",
      "notPracticedYet": "You haven't practised this sound yet.",
      "difficultyLabel": "Expected difficulty",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "This sound is usually hard for Spanish speakers.",
      "tipsTitle": "Tips",
      "practiceButton": "Practise this sound",
      "closeA11y": "Close sound details"
    },
    "practiceCard": {
      "title": "Sound Map",
      "subtitle": "Track your mastery of every sound",
      "cta": "Open the sound map"
    },
    "guidanceOnly": {
      "summary": "The English sounds that are hardest for Spanish speakers",
      "body": "These are the sounds of your English. The ones marked are the ones Spanish speakers usually find hardest — tap any of them for tips and to practise it with your tutor."
    }
  },
  "competenceMap": {
    "title": "Competence map",
    "loading": "Loading your competence map...",
    "loadError": "Could not load your competence map.",
    "progressLabel": "{{mastered}} of {{total}} competences mastered",
    "dueTitle": "Due for review",
    "bandEmpty": "There is no content at this level yet.",
    "bandCount_one": "{{count}} competence",
    "bandCount_other": "{{count}} competences",
    "bandLater_one": "{{count}} later on",
    "bandLater_other": "{{count}} later on",
    "summary": {
      "mastered_one": "{{count}} mastered",
      "mastered_other": "{{count}} mastered",
      "learning_one": "{{count}} in progress",
      "learning_other": "{{count}} in progress",
      "struggling_one": "{{count}} struggling",
      "struggling_other": "{{count}} struggling",
      "untried_one": "{{count}} not seen yet",
      "untried_other": "{{count}} not seen yet",
      "upcoming_one": "{{count}} later on",
      "upcoming_other": "{{count}} later on"
    },
    "bands": {
      "A1": "A1 · Beginner",
      "A2": "A2 · Elementary",
      "B1": "B1 · Intermediate",
      "B2": "B2 · Upper Int.",
      "C1": "C1 · Advanced",
      "C2": "C2 · Mastery",
      "any": "Any level"
    },
    "states": {
      "mastered": "Mastered",
      "learning": "In progress",
      "struggling": "Struggling",
      "untried": "Not seen yet",
      "upcoming": "Later on"
    },
    "chip": {
      "due": "Due",
      "a11y": "{{name}}, {{state}}",
      "a11yWithHard": "{{name}}, {{state}}, usually hard"
    },
    "detail": {
      "examplesTitle": "Examples",
      "exampleCorrect": "✓ {{text}}",
      "exampleIncorrect": "✗ {{text}}",
      "statsProductions": "Correct uses",
      "statsStruggles": "Mistakes",
      "statsSessions": "Sessions",
      "statsLastUsed": "Last used",
      "statsNextReview": "Next review",
      "notSeenYet": "We have not seen you use this yet.",
      "comesLater": "This comes later in your journey.",
      "difficultyLabel": "Expected difficulty",
      "difficultyValue": "{{difficulty}}/5",
      "expectedHard": "This is usually hard for Spanish speakers.",
      "tipsTitle": "Tips",
      "practiceButton": "Practise this",
      "closeA11y": "Close competence details"
    },
    "practiceCard": {
      "title": "Competence map",
      "subtitle": "Track your grammar mastery",
      "cta": "Open the competence map"
    }
  },
  "vocabulary": {
    "title": "Your vocabulary",
    "hubCard": {
      "title": "Your vocabulary",
      "subtitle": "Words and expressions you practise",
      "counts": "{{mastered}} mastered · {{due}} due for review"
    },
    "counts": {
      "new": "New",
      "learning": "Learning",
      "mastered": "Mastered"
    },
    "due": {
      "title": "Due for review",
      "empty": "Nothing due right now. Keep it up!",
      "more": "and {{overflow}} more due for review"
    },
    "list": {
      "learning": "Learning",
      "mastered": "Mastered",
      "empty": "Nothing here yet. Try a role play to get started."
    },
    "error": {
      "retry": "Retry"
    }
  },
  "errors": {
    "api": {
      "ROLEPLAY_TEMPLATE_NOT_FOUND": "This template is no longer available."
    }
  },
  "vocabSets": {
    "title": "Word sets",
    "drillTitle": "Practice",
    "loading": "Loading…",
    "loadError": "We couldn't load the word sets.",
    "intro": "Groups of words to practise directly. Type the English word — it only counts if you produce it yourself.",
    "countLabel": "{{done}} of {{total}} mastered",
    "inputPlaceholder": "Type the English word",
    "check": "Check",
    "reveal": "Show the answer",
    "next": "Next",
    "empty": "This set has no words yet.",
    "markError": "We couldn't save your answer. Please try again.",
    "speak": "Say it out loud",
    "pronunciationScore": "Pronunciation: {{score}}/100",
    "notHeard": "We couldn't hear you clearly. Try again."
  }
}
